import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const initialState = {
  lists: [],
  items: [],
  followers: [],
  followings: [],
  selectedTabIndex: {}
} as ProfileTabs

export const profileTabs = createSlice({
  name: "profileTabs",
  initialState: initialState,
  reducers: {
    updateListsTab: (state, action: PayloadAction<WishList[]>) => {
      state.lists = action.payload
    },
    updateItemsTab: (state, action: PayloadAction<WishItem[]>) => {
      state.items = action.payload
    },
    updateFollowersTab: (state, action: PayloadAction<UserFollowDto[]>) => {
      state.followers = action.payload || []
    },
    updateFollowingsTab: (state, action: PayloadAction<UserFollowDto[]>) => {
      state.followings = action.payload || []
    },
    updateSelectedTabIndex: (state, action: PayloadAction<{ handle: string, index: ProfileSelectedTabIndex }>) => {
      state.selectedTabIndex = { ...state.selectedTabIndex, [action.payload.handle]: action.payload.index }
    },
    resetProfileTabsSlice: (state) => {
      const { selectedTabIndex, ...restSlice } = structuredClone(initialState)
      return {
        selectedTabIndex: state.selectedTabIndex,
        ...restSlice
      }
    }
  }
})

export const {
  updateListsTab,
  updateItemsTab,
  updateSelectedTabIndex,
  updateFollowersTab,
  updateFollowingsTab,
  resetProfileTabsSlice
} = profileTabs.actions

export default profileTabs.reducer
